import { type CSSProperties, type RefObject, useLayoutEffect } from 'react';

/** 템플릿 머리(배너 · 헤더 · BackBar)의 실제 높이를 담는 CSS 변수 */
export const STICKY_TOP_VAR = '--app-sticky-top';

/** 본문 안에서 위에 붙는 줄의 위치 — 템플릿 머리 바로 아래. 머리가 없으면 0 */
export const STICKY_TOP_STYLE: CSSProperties = { top: `var(${STICKY_TOP_VAR}, 0px)` };

/**
 * 템플릿 머리가 자기 높이를 문서 루트의 CSS 변수로 알린다(대행 배너 · BackBar 유무에 따라 바뀐다).
 * 본문의 sticky 줄은 `STICKY_TOP_STYLE` 로 그 아래에 붙는다.
 */
export function usePublishStickyTop(ref: RefObject<HTMLElement | null>): void {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const root = document.documentElement;
    const publish = () => root.style.setProperty(STICKY_TOP_VAR, `${element.offsetHeight}px`);
    publish();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(publish);
    observer?.observe(element);
    return () => {
      observer?.disconnect();
      root.style.removeProperty(STICKY_TOP_VAR);
    };
  }, [ref]);
}
